







import { Component, Mixins } from "vue-property-decorator";
import { ExternalProcessItem } from "../../../../domain/document/items";
import {
  IConfiguration,
} from "../../../../domain/configuration";
import { IObjectStyleReadable } from "../IObjectStyleReadable";
import { ColorFixedObjectStyleReader } from "../styleReaders";
import {
  StyledDrawableObjectMixin
} from "./mixins";
import { UpdateKinds } from "../../../../domain/document";

@Component({
})

// 暫定で追加したのみの状態
// V1フォーマット上ではscriptlinkタグ
// [参考資料]
// \\192.168.2.222\共通フォルダ他\★Documaker\11_システム定義書\外部処理\【外部処理】外部処理について.xlsx
// http://git.pscad.co.jp:8080/gitbucket/documaker/DocuMakerV1.5/blob/5f00b8a1c8ed1f68f703a218157e85242d5c569c/src/findex/documaker/print/screen/data/FormatDataModel.java#L3110
export default class ExternalProcessObject extends Mixins(
  StyledDrawableObjectMixin
) {
  get editStyleReader(): IObjectStyleReadable {
    const configuration = this.$store.getters.configuration as IConfiguration;
    return new ColorFixedObjectStyleReader(configuration.style.document.editor.objects.externalProcess);
  }

  editingSource: ExternalProcessItem;

  get isButtonVisible(): boolean {
    return this.editingSource.updateKind === UpdateKinds.Clicked;
  }

  get buttonText(): string {
    return this.editingSource.name;
  }

  showDialog(): void {
    this.emitFocus();
    this.commonComponents.adapters.externalScript.executeExternalProcess(this.editingSource)
    .catch(e => {
        this.$error("エラー", "外部処理実行中にエラーが発生しました。", e);
    });
  }

  get buttonStyleProperties(): any {
    const fontSize = this.editingSource.textFontSize
      ? this.editingSource.textFontSize
      : 12;
    return {
      fontSize: fontSize + "px",
    };
  }
}
